const activePersonalizations = (personalizations) =>
  personalizations.filter((p) => p.active);

export default activePersonalizations;
